<template>
  <div>
    <div class="action">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="openBilDetail" v-bind="attrs" v-on="on">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </template>
        <span class="white--text">Xem chi tiết</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="$auth.policies['update-note-period']" icon @click="openNoteDialog" v-bind="attrs" v-on="on">
            <v-icon>mdi-file-document-edit</v-icon>
          </v-btn>
        </template>
        <span class="white--text">Bổ sung ghi chú</span>
      </v-tooltip>
      <v-tooltip v-if="viewIsPaid" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="!isPaid" icon @click="updateStatus" v-bind="attrs" v-on="on">
            <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
          </v-btn>
          <v-btn v-else icon @click="updateStatus" v-bind="attrs" v-on="on">
            <img :src="InfomationOffIcon" />
          </v-btn>
        </template>
        <span class="white--text">{{ !isPaid ? 'Đã nhận' : 'Chưa nhận' }}</span>
      </v-tooltip>
    </div>
    <edit-note-dialog ref="edit-note" />
    <DetailedBillDialog ref="detail-bill" />
  </div>
</template>
<script>
import InfomationOffIcon from '@/assets/collect.svg'
import DetailedBillDialog from '../report-detail/index.vue'
import EditNoteDialog from './EditNoteDialog.vue'
import { mapActions } from 'vuex'
export default {
  props: {
    report: Object,
    viewIsPaid: Boolean,
    isPaid: Boolean
  },
  data() {
    return {
      isEditNote: false,
      isOpenDialog: false,
      InfomationOffIcon
    }
  },
  components: {
    EditNoteDialog,
    DetailedBillDialog
  },
  methods: {
    ...mapActions({
      setReport: 'salaryReport/setReport',
      editStatusPaid: 'salaryReport/editStatusPaid'
    }),
    openNoteDialog() {
      console.log(this.report)
      this.setReport(this.report)
      this.$refs['edit-note'].openDialog()
    },
    openBilDetail() {
      console.log(this.report)
      this.setReport(this.report)
      this.$refs['detail-bill'].openDialog()
    },
    updateStatus() {
      this.$dialog.confirm({
        title: 'Xác nhận cập nhật trạng thái?',
        text: `<p style=" margin-bottom: 0px;">Thay đổi trạng thái thanh toán thành ${
          this.isPaid ? '<span class="red--text">Chưa nhận<span>' : '<span class="success--text">Đã nhận<span>'
        } sẽ ảnh hưởng đến tổng số tiền đã thu.</p><span>Bạn có muốn tiếp tục?</span>`,
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            let params = {
              isPaid: !this.isPaid,
              id: this.report.id
            }
            await this.editStatusPaid(params)
            this.$alert.success('Đã cập nhật thành công!')
          } catch (e) {
            this.$alert.error({ title: 'Lỗi kết nối', description: 'Không thể cập nhật. Vui lòng thử lại' })
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.action {
  min-width: 108px;
}
</style>
